export default [
    {
        "ProjectId":"0b11a307-1682-427d-9db2-726033357174",
        "Success": true,
        "Data": {
            "issueTypes": {
                "count": 12,
                "value": [
                    {
                        "name": "Issue",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Issue",
                        "description": "Issues track suggested improvements, changes or questions related to the project. Issues can also be used to break down an Epic into smaller chunks of work.",
                        "color": "339947",
                        "icon": {
                            "id": "icon_clipboard_issue",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_clipboard_issue?color=339947&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Epic",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Epic",
                        "description": "Epics can be defined as a large piece of work that has one common objective. Use an Epic to track the progress of complex features.",
                        "color": "E06C00",
                        "icon": {
                            "id": "icon_crown",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_crown?color=E06C00&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Task",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Task",
                        "description": "Tasks track the actual work that needs to be done.",
                        "color": "A4880A",
                        "icon": {
                            "id": "icon_check_box",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_check_box?color=A4880A&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Case",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestCase",
                        "description": "Server-side data for a set of steps to be tested.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_case",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_case?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Plan",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestPlan",
                        "description": "Tracks test activities for a specific milestone or release.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_plan",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_plan?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Suite",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestSuite",
                        "description": "Tracks test activites for a specific feature, requirement, or user story.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_suite",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_suite?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Shared Steps",
                        "referenceName": "Microsoft.VSTS.IssueTypes.SharedStep",
                        "description": "Server-side data for reusable set of test steps.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_step",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_step?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Shared Parameter",
                        "referenceName": "Microsoft.VSTS.IssueTypes.SharedParameter",
                        "description": "Server-side data for reusable set of parameter.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_parameter",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_parameter?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Code Review Request",
                        "referenceName": "Microsoft.VSTS.IssueTypes.CodeReviewRequest",
                        "description": "Represents the master work item for a code review. Child work items should be created of the type Code Review Response.",
                        "color": "B4009E",
                        "icon": {
                            "id": "icon_code_review",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_code_review?color=B4009E&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Code Review Response",
                        "referenceName": "Microsoft.VSTS.IssueTypes.CodeReviewResponse",
                        "description": "This is a child work item that should be parented to a Code Review Request work item. It is assigned to the reviewer and contains the current state of the review for this reviewer.",
                        "color": "B4009E",
                        "icon": {
                            "id": "icon_code_response",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_code_response?color=B4009E&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Feedback Request",
                        "referenceName": "Microsoft.VSTS.IssueTypes.FeedbackRequest",
                        "description": "Represents the master work item for a feedback session. Child work items should be created of the type Feedback Response.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_review",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_review?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Feedback Response",
                        "referenceName": "Microsoft.VSTS.IssueTypes.FeedbackResponse",
                        "description": "This is a child work item that should be parented to a Feedback Request work item. It is assigned to the reviewer and contains the current state of the review for this reviewer.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_response",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_response?color=004B50&v=2"
                        },
                        "isDisabled": false
                    }
                ]
            },
            "nodesList": {
                "count": 2,
                "value": [
                    {
                        "id": 8,
                        "identifier": "e2cad10d-9d03-42a0-8e51-464ee1c08f73",
                        "structureType": "area",
                        "hasChildren": false,
                        "path": "\\Second Project\\Area",
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/classificationNodes/Areas",
                        "text": "Second Project"
                    },
                    {
                        "id": 5,
                        "identifier": "7e5e35c1-1bb2-45fc-85ea-d3c491a4b778",
                        "structureType": "iteration",
                        "hasChildren": true,
                        "children": [
                            {
                                "id": 7,
                                "identifier": "695c0f35-5dc7-4750-8089-7957b787eda1",
                                "structureType": "iteration",
                                "hasChildren": false,
                                "path": "\\Second Project\\Iteration\\Sprint 1",
                                "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/classificationNodes/Iterations/Sprint%201",
                                "text": "Sprint 1"
                            }
                        ],
                        "path": "\\Second Project\\Iteration",
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/classificationNodes/Iterations",
                        "text": "Second Project"
                    }
                ]
            },
            "fieldsList": {
                "count": 60,
                "value": [
                    {
                        "name": "Accepted By",
                        "referenceName": "Microsoft.VSTS.CodeReview.AcceptedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.AcceptedBy"
                    },
                    {
                        "name": "Accepted Date",
                        "referenceName": "Microsoft.VSTS.CodeReview.AcceptedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.AcceptedDate"
                    },
                    {
                        "name": "Activated By",
                        "referenceName": "Microsoft.VSTS.Common.ActivatedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.ActivatedBy"
                    },
                    {
                        "name": "Activated Date",
                        "referenceName": "Microsoft.VSTS.Common.ActivatedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.ActivatedDate"
                    },
                    {
                        "name": "Activity",
                        "referenceName": "Microsoft.VSTS.Common.Activity",
                        "description": "Type of work involved",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.Activity"
                    },
                    {
                        "name": "Application Launch Instructions",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationLaunchInstructions",
                        "description": "Instructions to launch the specified application",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationLaunchInstructions"
                    },
                    {
                        "name": "Application Start Information",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationStartInformation",
                        "description": "The path to execute the application",
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationStartInformation"
                    },
                    {
                        "name": "Application Type",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationType",
                        "description": "The type of application on which to give feedback",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationType"
                    },
                    {
                        "name": "Area ID",
                        "referenceName": "System.AreaId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.AreaId"
                    },
                    {
                        "name": "Area Path",
                        "referenceName": "System.AreaPath",
                        "description": "The area of the product with which this bug is associated",
                        "type": "treePath",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.AreaPath"
                    },
                    {
                        "name": "Assigned To",
                        "referenceName": "System.AssignedTo",
                        "description": "The person currently working on this bug",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.AssignedTo"
                    },
                    {
                        "name": "Associated Context",
                        "referenceName": "Microsoft.VSTS.CodeReview.Context",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.Context"
                    },
                    {
                        "name": "Associated Context Code",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextCode"
                    },
                    {
                        "name": "Associated Context Owner",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextOwner",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextOwner"
                    },
                    {
                        "name": "Associated Context Type",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextType",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextType"
                    },
                    {
                        "name": "Automated Test Id",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestId",
                        "description": "The ID of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestId"
                    },
                    {
                        "name": "Automated Test Name",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestName",
                        "description": "The name of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestName"
                    },
                    {
                        "name": "Automated Test Storage",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestStorage",
                        "description": "The assembly containing the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestStorage"
                    },
                    {
                        "name": "Automated Test Type",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestType",
                        "description": "The type of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestType"
                    },
                    {
                        "name": "Automation status",
                        "referenceName": "Microsoft.VSTS.TCM.AutomationStatus",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.AutomationStatus"
                    },
                    {
                        "name": "Changed By",
                        "referenceName": "System.ChangedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.ChangedBy"
                    },
                    {
                        "name": "Closed By",
                        "referenceName": "Microsoft.VSTS.Common.ClosedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.ClosedBy"
                    },
                    {
                        "name": "Closed Date",
                        "referenceName": "Microsoft.VSTS.Common.ClosedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.ClosedDate"
                    },
                    {
                        "name": "Closed Status",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosedStatus",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosedStatus"
                    },
                    {
                        "name": "Closed Status Code",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosedStatusCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosedStatusCode"
                    },
                    {
                        "name": "Closing Comment",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosingComment",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosingComment"
                    },
                    {
                        "name": "Completed Work",
                        "referenceName": "Microsoft.VSTS.Scheduling.CompletedWork",
                        "description": "The number of units of work that have been spent on this bug",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Scheduling.CompletedWork"
                    },
                    {
                        "name": "Description",
                        "referenceName": "System.Description",
                        "description": "Description or acceptance criteria for this epic to be considered complete",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.Description"
                    },
                    {
                        "name": "Effort",
                        "referenceName": "Microsoft.VSTS.Scheduling.Effort",
                        "description": "The estimated effort to implemented the epic",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Scheduling.Effort"
                    },
                    {
                        "name": "Finish Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.FinishDate",
                        "description": "The date to finish the task",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Scheduling.FinishDate"
                    },
                    {
                        "name": "History",
                        "referenceName": "System.History",
                        "description": "Discussion thread plus automatic record of changes",
                        "type": "history",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.History"
                    },
                    {
                        "name": "Integration Build",
                        "referenceName": "Microsoft.VSTS.Build.IntegrationBuild",
                        "description": "The build in which the bug was fixed",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Build.IntegrationBuild"
                    },
                    {
                        "name": "Issue",
                        "referenceName": "Microsoft.VSTS.Common.Issue",
                        "description": "Used to highlight the shared step, e.g., to mark it as an issue",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.Issue"
                    },
                    {
                        "name": "Iteration ID",
                        "referenceName": "System.IterationId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.IterationId"
                    },
                    {
                        "name": "Iteration Path",
                        "referenceName": "System.IterationPath",
                        "description": "The iteration within which this bug will be fixed",
                        "type": "treePath",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.IterationPath"
                    },
                    {
                        "name": "Local Data Source",
                        "referenceName": "Microsoft.VSTS.TCM.LocalDataSource",
                        "description": null,
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.LocalDataSource"
                    },
                    {
                        "name": "Parameters",
                        "referenceName": "Microsoft.VSTS.TCM.Parameters",
                        "description": null,
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.Parameters"
                    },
                    {
                        "name": "Priority",
                        "referenceName": "Microsoft.VSTS.Common.Priority",
                        "description": "Business importance. 1=must fix; 4=unimportant.",
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.Priority"
                    },
                    {
                        "name": "Query Text",
                        "referenceName": "Microsoft.VSTS.TCM.QueryText",
                        "description": null,
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.QueryText"
                    },
                    {
                        "name": "Rating",
                        "referenceName": "Microsoft.VSTS.Common.Rating",
                        "description": "Overall rating provided as part of feedback response",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.Rating"
                    },
                    {
                        "name": "Reason",
                        "referenceName": "System.Reason",
                        "description": "The reason why the bug is in the current state",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.Reason"
                    },
                    {
                        "name": "Remaining Work",
                        "referenceName": "Microsoft.VSTS.Scheduling.RemainingWork",
                        "description": "An estimate of the number of units of work remaining to complete this bug",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Scheduling.RemainingWork"
                    },
                    {
                        "name": "Resolved By",
                        "referenceName": "Microsoft.VSTS.Common.ResolvedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.ResolvedBy"
                    },
                    {
                        "name": "Resolved Date",
                        "referenceName": "Microsoft.VSTS.Common.ResolvedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.ResolvedDate"
                    },
                    {
                        "name": "Reviewed By",
                        "referenceName": "Microsoft.VSTS.Common.ReviewedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.ReviewedBy"
                    },
                    {
                        "name": "Stack Rank",
                        "referenceName": "Microsoft.VSTS.Common.StackRank",
                        "description": "Work first on items with lower-valued stack rank. Set in triage.",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.StackRank"
                    },
                    {
                        "name": "Start Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.StartDate",
                        "description": "The date to start the task",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Scheduling.StartDate"
                    },
                    {
                        "name": "State",
                        "referenceName": "System.State",
                        "description": "New = for triage; Active = not yet fixed; Resolved = fixed not yet verified; Closed = fix verified.",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.State"
                    },
                    {
                        "name": "State Change Date",
                        "referenceName": "Microsoft.VSTS.Common.StateChangeDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.StateChangeDate"
                    },
                    {
                        "name": "State Code",
                        "referenceName": "Microsoft.VSTS.Common.StateCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Common.StateCode"
                    },
                    {
                        "name": "Steps",
                        "referenceName": "Microsoft.VSTS.TCM.Steps",
                        "description": "Steps required to perform the test",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.Steps"
                    },
                    {
                        "name": "System Info",
                        "referenceName": "Microsoft.VSTS.TCM.SystemInfo",
                        "description": "Test context, provided automatically by test infrastructure",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.SystemInfo"
                    },
                    {
                        "name": "Tags",
                        "referenceName": "System.Tags",
                        "description": null,
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.Tags"
                    },
                    {
                        "name": "Target Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.TargetDate",
                        "description": "The target date for completing the epic",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.Scheduling.TargetDate"
                    },
                    {
                        "name": "Team Project",
                        "referenceName": "System.TeamProject",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.TeamProject"
                    },
                    {
                        "name": "Test Suite Audit",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteAudit",
                        "description": "Captures the test suite audit trail.",
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteAudit"
                    },
                    {
                        "name": "Test Suite Type",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteType",
                        "description": "Specifies the category of the test suite.",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteType"
                    },
                    {
                        "name": "Test Suite Type Id",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteTypeId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteTypeId"
                    },
                    {
                        "name": "Title",
                        "referenceName": "System.Title",
                        "description": "Stories affected and how",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.Title"
                    },
                    {
                        "name": "Issue Type",
                        "referenceName": "System.IssueType",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/0b11a307-1682-427d-9db2-726033357174/_apis/wit/fields/System.IssueType"
                    },
                    {
                        "name": "Issue #",
                        "referenceName": "id",
                        "type": "number"
                    }
                ]
            },
            "usersList": {
                "count": 3,
                "value": [
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "devopsintegration.dev@gmail.com",
                        "mailAddress": "devopsintegration.dev@gmail.com",
                        "origin": "msa",
                        "originId": "000300003A96BD95",
                        "displayName": "devopsintegration.dev",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj",
                        "descriptor": "msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                    },
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "support@devopsintegration.io",
                        "mailAddress": "support@devopsintegration.io",
                        "origin": "msa",
                        "originId": "000300003A96D958",
                        "displayName": "Jira Support",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3",
                        "descriptor": "msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                    },
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "devopsintegration.io@outlook.com",
                        "mailAddress": "devopsintegration.io@outlook.com",
                        "origin": "msa",
                        "originId": "00037FFE39B2B15E",
                        "displayName": "Jira Integration",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi",
                        "descriptor": "msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                    }
                ]
            }
        }
    },
    {
        "ProjectId":"9ee885ad-3670-4f11-ae60-01d415a5af12",
        "Success": true,
        "Data": {
            "issueTypes": {
                "count": 12,
                "value": [
                    {
                        "name": "Issue",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Issue",
                        "description": "Issues track suggested improvements, changes or questions related to the project. Issues can also be used to break down an Epic into smaller chunks of work.",
                        "color": "339947",
                        "icon": {
                            "id": "icon_clipboard_issue",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_clipboard_issue?color=339947&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Epic",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Epic",
                        "description": "Epics can be defined as a large piece of work that has one common objective. Use an Epic to track the progress of complex features.",
                        "color": "E06C00",
                        "icon": {
                            "id": "icon_crown",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_crown?color=E06C00&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Task",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Task",
                        "description": "Tasks track the actual work that needs to be done.",
                        "color": "A4880A",
                        "icon": {
                            "id": "icon_check_box",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_check_box?color=A4880A&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Case",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestCase",
                        "description": "Server-side data for a set of steps to be tested.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_case",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_case?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Plan",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestPlan",
                        "description": "Tracks test activities for a specific milestone or release.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_plan",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_plan?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Suite",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestSuite",
                        "description": "Tracks test activites for a specific feature, requirement, or user story.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_suite",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_suite?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Shared Steps",
                        "referenceName": "Microsoft.VSTS.IssueTypes.SharedStep",
                        "description": "Server-side data for reusable set of test steps.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_step",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_step?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Shared Parameter",
                        "referenceName": "Microsoft.VSTS.IssueTypes.SharedParameter",
                        "description": "Server-side data for reusable set of parameter.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_parameter",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_parameter?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Code Review Request",
                        "referenceName": "Microsoft.VSTS.IssueTypes.CodeReviewRequest",
                        "description": "Represents the master work item for a code review. Child work items should be created of the type Code Review Response.",
                        "color": "B4009E",
                        "icon": {
                            "id": "icon_code_review",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_code_review?color=B4009E&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Code Review Response",
                        "referenceName": "Microsoft.VSTS.IssueTypes.CodeReviewResponse",
                        "description": "This is a child work item that should be parented to a Code Review Request work item. It is assigned to the reviewer and contains the current state of the review for this reviewer.",
                        "color": "B4009E",
                        "icon": {
                            "id": "icon_code_response",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_code_response?color=B4009E&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Feedback Request",
                        "referenceName": "Microsoft.VSTS.IssueTypes.FeedbackRequest",
                        "description": "Represents the master work item for a feedback session. Child work items should be created of the type Feedback Response.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_review",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_review?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Feedback Response",
                        "referenceName": "Microsoft.VSTS.IssueTypes.FeedbackResponse",
                        "description": "This is a child work item that should be parented to a Feedback Request work item. It is assigned to the reviewer and contains the current state of the review for this reviewer.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_response",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_response?color=004B50&v=2"
                        },
                        "isDisabled": false
                    }
                ]
            },
            "nodesList": {
                "count": 2,
                "value": [
                    {
                        "id": 4,
                        "identifier": "62c7c1cb-807e-425e-86a8-81ee671879f7",
                        "structureType": "area",
                        "hasChildren": false,
                        "path": "\\First Project\\Area",
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/classificationNodes/Areas",
                        "text": "First Project"
                    },
                    {
                        "id": 1,
                        "identifier": "6891bcfc-f4bc-4178-afe4-42eedabc5b9a",
                        "structureType": "iteration",
                        "hasChildren": true,
                        "children": [
                            {
                                "id": 3,
                                "identifier": "0c06b577-f8d9-4098-9565-c041ef554334",
                                "structureType": "iteration",
                                "hasChildren": false,
                                "path": "\\First Project\\Iteration\\Sprint 1",
                                "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/classificationNodes/Iterations/Sprint%201",
                                "text": "Sprint 1"
                            }
                        ],
                        "path": "\\First Project\\Iteration",
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/classificationNodes/Iterations",
                        "text": "First Project"
                    }
                ]
            },
            "fieldsList": {
                "count": 72,
                "value": [
                    {
                        "name": "Accepted By",
                        "referenceName": "Microsoft.VSTS.CodeReview.AcceptedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.AcceptedBy"
                    },
                    {
                        "name": "Accepted Date",
                        "referenceName": "Microsoft.VSTS.CodeReview.AcceptedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.AcceptedDate"
                    },
                    {
                        "name": "Activated By",
                        "referenceName": "Microsoft.VSTS.Common.ActivatedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.ActivatedBy"
                    },
                    {
                        "name": "Activated Date",
                        "referenceName": "Microsoft.VSTS.Common.ActivatedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.ActivatedDate"
                    },
                    {
                        "name": "Activity",
                        "referenceName": "Microsoft.VSTS.Common.Activity",
                        "description": "Type of work involved",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.Activity"
                    },
                    {
                        "name": "Application Launch Instructions",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationLaunchInstructions",
                        "description": "Instructions to launch the specified application",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationLaunchInstructions"
                    },
                    {
                        "name": "Application Start Information",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationStartInformation",
                        "description": "The path to execute the application",
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationStartInformation"
                    },
                    {
                        "name": "Application Type",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationType",
                        "description": "The type of application on which to give feedback",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationType"
                    },
                    {
                        "name": "Area ID",
                        "referenceName": "System.AreaId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.AreaId"
                    },
                    {
                        "name": "Area Path",
                        "referenceName": "System.AreaPath",
                        "description": "The area of the product with which this bug is associated",
                        "type": "treePath",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.AreaPath"
                    },
                    {
                        "name": "Assigned To",
                        "referenceName": "System.AssignedTo",
                        "description": "The person currently working on this bug",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.AssignedTo"
                    },
                    {
                        "name": "Associated Context",
                        "referenceName": "Microsoft.VSTS.CodeReview.Context",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.Context"
                    },
                    {
                        "name": "Associated Context Code",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextCode"
                    },
                    {
                        "name": "Associated Context Owner",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextOwner",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextOwner"
                    },
                    {
                        "name": "Associated Context Type",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextType",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextType"
                    },
                    {
                        "name": "Automated Test Id",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestId",
                        "description": "The ID of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestId"
                    },
                    {
                        "name": "Automated Test Name",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestName",
                        "description": "The name of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestName"
                    },
                    {
                        "name": "Automated Test Storage",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestStorage",
                        "description": "The assembly containing the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestStorage"
                    },
                    {
                        "name": "Automated Test Type",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestType",
                        "description": "The type of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestType"
                    },
                    {
                        "name": "Automation status",
                        "referenceName": "Microsoft.VSTS.TCM.AutomationStatus",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.AutomationStatus"
                    },
                    {
                        "name": "Bool F",
                        "referenceName": "Custom.BoolF",
                        "description": "test field for boolean",
                        "type": "boolean",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.BoolF",
                        "defaultValue": false
                    },
                    {
                        "name": "Changed By",
                        "referenceName": "System.ChangedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.ChangedBy"
                    },
                    {
                        "name": "Closed By",
                        "referenceName": "Microsoft.VSTS.Common.ClosedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.ClosedBy"
                    },
                    {
                        "name": "Closed Date",
                        "referenceName": "Microsoft.VSTS.Common.ClosedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.ClosedDate"
                    },
                    {
                        "name": "Closed Status",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosedStatus",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosedStatus"
                    },
                    {
                        "name": "Closed Status Code",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosedStatusCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosedStatusCode"
                    },
                    {
                        "name": "Closing Comment",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosingComment",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosingComment"
                    },
                    {
                        "name": "Completed Work",
                        "referenceName": "Microsoft.VSTS.Scheduling.CompletedWork",
                        "description": "The number of units of work that have been spent on this bug",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Scheduling.CompletedWork"
                    },
                    {
                        "name": "Decimal F",
                        "referenceName": "Custom.DecimalF",
                        "description": "decimal field",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.DecimalF"
                    },
                    {
                        "name": "Description",
                        "referenceName": "System.Description",
                        "description": "Description or acceptance criteria for this epic to be considered complete",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.Description"
                    },
                    {
                        "name": "Development",
                        "referenceName": "Custom.Development",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.Development"
                    },
                    {
                        "name": "Dropdown Int",
                        "referenceName": "Custom.DropdownInt",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": true,
                        "isPicklistSuggested": false,
                        "picklistId": "b92936a1-21a7-4774-bec2-bef32299392b",
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.DropdownInt",
                        "allowedValues": [
                            "1",
                            "2",
                            "3"
                        ]
                    },
                    {
                        "name": "Effort",
                        "referenceName": "Microsoft.VSTS.Scheduling.Effort",
                        "description": "The estimated effort to implemented the epic",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Scheduling.Effort"
                    },
                    {
                        "name": "Finish Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.FinishDate",
                        "description": "The date to finish the task",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Scheduling.FinishDate"
                    },
                    {
                        "name": "Freshdesk Ticket #",
                        "referenceName": "Custom.FreshdeskTicket#",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.FreshdeskTicket#"
                    },
                    {
                        "name": "Freshservice Ticket #",
                        "referenceName": "Custom.FreshserviceTicket#",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.FreshserviceTicket#"
                    },
                    {
                        "name": "History",
                        "referenceName": "System.History",
                        "description": "Discussion thread plus automatic record of changes",
                        "type": "history",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.History"
                    },
                    {
                        "name": "Identity F",
                        "referenceName": "Custom.IdentityF",
                        "description": "identity field",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.IdentityF"
                    },
                    {
                        "name": "Integer F",
                        "referenceName": "Custom.IntegerF",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.IntegerF"
                    },
                    {
                        "name": "Integration Build",
                        "referenceName": "Microsoft.VSTS.Build.IntegrationBuild",
                        "description": "The build in which the bug was fixed",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Build.IntegrationBuild"
                    },
                    {
                        "name": "Issue",
                        "referenceName": "Microsoft.VSTS.Common.Issue",
                        "description": "Used to highlight the shared step, e.g., to mark it as an issue",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.Issue"
                    },
                    {
                        "name": "Iteration ID",
                        "referenceName": "System.IterationId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.IterationId"
                    },
                    {
                        "name": "Iteration Path",
                        "referenceName": "System.IterationPath",
                        "description": "The iteration within which this bug will be fixed",
                        "type": "treePath",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.IterationPath"
                    },
                    {
                        "name": "Local Data Source",
                        "referenceName": "Microsoft.VSTS.TCM.LocalDataSource",
                        "description": null,
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.LocalDataSource"
                    },
                    {
                        "name": "Parameters",
                        "referenceName": "Microsoft.VSTS.TCM.Parameters",
                        "description": null,
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.Parameters"
                    },
                    {
                        "name": "Priority",
                        "referenceName": "Microsoft.VSTS.Common.Priority",
                        "description": "Business importance. 1=must fix; 4=unimportant.",
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.Priority"
                    },
                    {
                        "name": "Product Name",
                        "referenceName": "Custom.ProductName",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": true,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.ProductName",
                        "allowedValues": [
                            "Zendesk",
                            "Freshdesk",
                            "Freshservice"
                        ]
                    },
                    {
                        "name": "Promise",
                        "referenceName": "Custom.Promise",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.Promise"
                    },
                    {
                        "name": "Query Text",
                        "referenceName": "Microsoft.VSTS.TCM.QueryText",
                        "description": null,
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.QueryText"
                    },
                    {
                        "name": "Rating",
                        "referenceName": "Microsoft.VSTS.Common.Rating",
                        "description": "Overall rating provided as part of feedback response",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.Rating"
                    },
                    {
                        "name": "Reason",
                        "referenceName": "System.Reason",
                        "description": "The reason why the bug is in the current state",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.Reason"
                    },
                    {
                        "name": "Remaining Work",
                        "referenceName": "Microsoft.VSTS.Scheduling.RemainingWork",
                        "description": "An estimate of the number of units of work remaining to complete this bug",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Scheduling.RemainingWork"
                    },
                    {
                        "name": "Resolved By",
                        "referenceName": "Microsoft.VSTS.Common.ResolvedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.ResolvedBy"
                    },
                    {
                        "name": "Resolved Date",
                        "referenceName": "Microsoft.VSTS.Common.ResolvedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.ResolvedDate"
                    },
                    {
                        "name": "Reviewed By",
                        "referenceName": "Microsoft.VSTS.Common.ReviewedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.ReviewedBy"
                    },
                    {
                        "name": "Stack Rank",
                        "referenceName": "Microsoft.VSTS.Common.StackRank",
                        "description": "Work first on items with lower-valued stack rank. Set in triage.",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.StackRank"
                    },
                    {
                        "name": "Start Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.StartDate",
                        "description": "The date to start the task",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Scheduling.StartDate"
                    },
                    {
                        "name": "State",
                        "referenceName": "System.State",
                        "description": "New = for triage; Active = not yet fixed; Resolved = fixed not yet verified; Closed = fix verified.",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.State"
                    },
                    {
                        "name": "State Change Date",
                        "referenceName": "Microsoft.VSTS.Common.StateChangeDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.StateChangeDate"
                    },
                    {
                        "name": "State Code",
                        "referenceName": "Microsoft.VSTS.Common.StateCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Common.StateCode"
                    },
                    {
                        "name": "Steps",
                        "referenceName": "Microsoft.VSTS.TCM.Steps",
                        "description": "Steps required to perform the test",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.Steps"
                    },
                    {
                        "name": "System Info",
                        "referenceName": "Microsoft.VSTS.TCM.SystemInfo",
                        "description": "Test context, provided automatically by test infrastructure",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.SystemInfo"
                    },
                    {
                        "name": "Tags",
                        "referenceName": "System.Tags",
                        "description": null,
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.Tags"
                    },
                    {
                        "name": "Target Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.TargetDate",
                        "description": "The target date for completing the epic",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.Scheduling.TargetDate"
                    },
                    {
                        "name": "Team Project",
                        "referenceName": "System.TeamProject",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.TeamProject"
                    },
                    {
                        "name": "Test Suite Audit",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteAudit",
                        "description": "Captures the test suite audit trail.",
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteAudit"
                    },
                    {
                        "name": "Test Suite Type",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteType",
                        "description": "Specifies the category of the test suite.",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteType"
                    },
                    {
                        "name": "Test Suite Type Id",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteTypeId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteTypeId"
                    },
                    {
                        "name": "Text M",
                        "referenceName": "Custom.TextM",
                        "description": null,
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.TextM"
                    },
                    {
                        "name": "Title",
                        "referenceName": "System.Title",
                        "description": "Stories affected and how",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.Title"
                    },
                    {
                        "name": "Issue Type",
                        "referenceName": "System.IssueType",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/System.IssueType"
                    },
                    {
                        "name": "Zendesk Ticket #",
                        "referenceName": "Custom.ZendeskTicket#",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/9ee885ad-3670-4f11-ae60-01d415a5af12/_apis/wit/fields/Custom.ZendeskTicket#"
                    },
                    {
                        "name": "Issue #",
                        "referenceName": "id",
                        "type": "number"
                    }
                ]
            },
            "usersList": {
                "count": 3,
                "value": [
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "devopsintegration.dev@gmail.com",
                        "mailAddress": "devopsintegration.dev@gmail.com",
                        "origin": "msa",
                        "originId": "000300003A96BD95",
                        "displayName": "devopsintegration.dev",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj",
                        "descriptor": "msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                    },
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "support@devopsintegration.io",
                        "mailAddress": "support@devopsintegration.io",
                        "origin": "msa",
                        "originId": "000300003A96D958",
                        "displayName": "Jira Support",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3",
                        "descriptor": "msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                    },
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "devopsintegration.io@outlook.com",
                        "mailAddress": "devopsintegration.io@outlook.com",
                        "origin": "msa",
                        "originId": "00037FFE39B2B15E",
                        "displayName": "Jira Integration",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi",
                        "descriptor": "msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                    }
                ]
            }
        }
    },
    {
        "ProjectId":"19720a67-640b-4be6-a041-4f05a404ac66",
        "Success": true,
        "Data": {
            "issueTypes": {
                "count": 12,
                "value": [
                    {
                        "name": "Issue",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Issue",
                        "description": "Issues track suggested improvements, changes or questions related to the project. Issues can also be used to break down an Epic into smaller chunks of work.",
                        "color": "339947",
                        "icon": {
                            "id": "icon_clipboard_issue",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_clipboard_issue?color=339947&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Epic",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Epic",
                        "description": "Epics can be defined as a large piece of work that has one common objective. Use an Epic to track the progress of complex features.",
                        "color": "E06C00",
                        "icon": {
                            "id": "icon_crown",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_crown?color=E06C00&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Task",
                        "referenceName": "Microsoft.VSTS.IssueTypes.Task",
                        "description": "Tasks track the actual work that needs to be done.",
                        "color": "A4880A",
                        "icon": {
                            "id": "icon_check_box",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_check_box?color=A4880A&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Case",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestCase",
                        "description": "Server-side data for a set of steps to be tested.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_case",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_case?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Plan",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestPlan",
                        "description": "Tracks test activities for a specific milestone or release.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_plan",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_plan?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Test Suite",
                        "referenceName": "Microsoft.VSTS.IssueTypes.TestSuite",
                        "description": "Tracks test activites for a specific feature, requirement, or user story.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_suite",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_suite?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Shared Steps",
                        "referenceName": "Microsoft.VSTS.IssueTypes.SharedStep",
                        "description": "Server-side data for reusable set of test steps.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_step",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_step?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Shared Parameter",
                        "referenceName": "Microsoft.VSTS.IssueTypes.SharedParameter",
                        "description": "Server-side data for reusable set of parameter.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_test_parameter",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_test_parameter?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Code Review Request",
                        "referenceName": "Microsoft.VSTS.IssueTypes.CodeReviewRequest",
                        "description": "Represents the master work item for a code review. Child work items should be created of the type Code Review Response.",
                        "color": "B4009E",
                        "icon": {
                            "id": "icon_code_review",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_code_review?color=B4009E&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Code Review Response",
                        "referenceName": "Microsoft.VSTS.IssueTypes.CodeReviewResponse",
                        "description": "This is a child work item that should be parented to a Code Review Request work item. It is assigned to the reviewer and contains the current state of the review for this reviewer.",
                        "color": "B4009E",
                        "icon": {
                            "id": "icon_code_response",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_code_response?color=B4009E&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Feedback Request",
                        "referenceName": "Microsoft.VSTS.IssueTypes.FeedbackRequest",
                        "description": "Represents the master work item for a feedback session. Child work items should be created of the type Feedback Response.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_review",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_review?color=004B50&v=2"
                        },
                        "isDisabled": false
                    },
                    {
                        "name": "Feedback Response",
                        "referenceName": "Microsoft.VSTS.IssueTypes.FeedbackResponse",
                        "description": "This is a child work item that should be parented to a Feedback Request work item. It is assigned to the reviewer and contains the current state of the review for this reviewer.",
                        "color": "004B50",
                        "icon": {
                            "id": "icon_response",
                            "url": "https://tfsprodsin1.visualstudio.com/_apis/wit/issueIcons/icon_response?color=004B50&v=2"
                        },
                        "isDisabled": false
                    }
                ]
            },
            "nodesList": {
                "count": 2,
                "value": [
                    {
                        "id": 12,
                        "identifier": "7e3d758d-7f3d-466d-a091-63a34cc460ca",
                        "structureType": "area",
                        "hasChildren": false,
                        "path": "\\Third Project\\Area",
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/classificationNodes/Areas",
                        "text": "Third Project"
                    },
                    {
                        "id": 9,
                        "identifier": "46b0b148-42e9-42ab-b034-bcee6407495a",
                        "structureType": "iteration",
                        "hasChildren": true,
                        "children": [
                            {
                                "id": 11,
                                "identifier": "fea303c0-a553-41a3-adad-f078e8b0ef80",
                                "structureType": "iteration",
                                "hasChildren": false,
                                "path": "\\Third Project\\Iteration\\Sprint 1",
                                "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/classificationNodes/Iterations/Sprint%201",
                                "text": "Sprint 1"
                            }
                        ],
                        "path": "\\Third Project\\Iteration",
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/classificationNodes/Iterations",
                        "text": "Third Project"
                    }
                ]
            },
            "fieldsList": {
                "count": 60,
                "value": [
                    {
                        "name": "Accepted By",
                        "referenceName": "Microsoft.VSTS.CodeReview.AcceptedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.AcceptedBy"
                    },
                    {
                        "name": "Accepted Date",
                        "referenceName": "Microsoft.VSTS.CodeReview.AcceptedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.AcceptedDate"
                    },
                    {
                        "name": "Activated By",
                        "referenceName": "Microsoft.VSTS.Common.ActivatedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.ActivatedBy"
                    },
                    {
                        "name": "Activated Date",
                        "referenceName": "Microsoft.VSTS.Common.ActivatedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.ActivatedDate"
                    },
                    {
                        "name": "Activity",
                        "referenceName": "Microsoft.VSTS.Common.Activity",
                        "description": "Type of work involved",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.Activity"
                    },
                    {
                        "name": "Application Launch Instructions",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationLaunchInstructions",
                        "description": "Instructions to launch the specified application",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationLaunchInstructions"
                    },
                    {
                        "name": "Application Start Information",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationStartInformation",
                        "description": "The path to execute the application",
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationStartInformation"
                    },
                    {
                        "name": "Application Type",
                        "referenceName": "Microsoft.VSTS.Feedback.ApplicationType",
                        "description": "The type of application on which to give feedback",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Feedback.ApplicationType"
                    },
                    {
                        "name": "Area ID",
                        "referenceName": "System.AreaId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.AreaId"
                    },
                    {
                        "name": "Area Path",
                        "referenceName": "System.AreaPath",
                        "description": "The area of the product with which this bug is associated",
                        "type": "treePath",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.AreaPath"
                    },
                    {
                        "name": "Assigned To",
                        "referenceName": "System.AssignedTo",
                        "description": "The person currently working on this bug",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.AssignedTo"
                    },
                    {
                        "name": "Associated Context",
                        "referenceName": "Microsoft.VSTS.CodeReview.Context",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.Context"
                    },
                    {
                        "name": "Associated Context Code",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextCode"
                    },
                    {
                        "name": "Associated Context Owner",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextOwner",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextOwner"
                    },
                    {
                        "name": "Associated Context Type",
                        "referenceName": "Microsoft.VSTS.CodeReview.ContextType",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.ContextType"
                    },
                    {
                        "name": "Automated Test Id",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestId",
                        "description": "The ID of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestId"
                    },
                    {
                        "name": "Automated Test Name",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestName",
                        "description": "The name of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestName"
                    },
                    {
                        "name": "Automated Test Storage",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestStorage",
                        "description": "The assembly containing the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestStorage"
                    },
                    {
                        "name": "Automated Test Type",
                        "referenceName": "Microsoft.VSTS.TCM.AutomatedTestType",
                        "description": "The type of the test that automates this test case",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.AutomatedTestType"
                    },
                    {
                        "name": "Automation status",
                        "referenceName": "Microsoft.VSTS.TCM.AutomationStatus",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.AutomationStatus"
                    },
                    {
                        "name": "Changed By",
                        "referenceName": "System.ChangedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.ChangedBy"
                    },
                    {
                        "name": "Closed By",
                        "referenceName": "Microsoft.VSTS.Common.ClosedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.ClosedBy"
                    },
                    {
                        "name": "Closed Date",
                        "referenceName": "Microsoft.VSTS.Common.ClosedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.ClosedDate"
                    },
                    {
                        "name": "Closed Status",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosedStatus",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosedStatus"
                    },
                    {
                        "name": "Closed Status Code",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosedStatusCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosedStatusCode"
                    },
                    {
                        "name": "Closing Comment",
                        "referenceName": "Microsoft.VSTS.CodeReview.ClosingComment",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.CodeReview.ClosingComment"
                    },
                    {
                        "name": "Completed Work",
                        "referenceName": "Microsoft.VSTS.Scheduling.CompletedWork",
                        "description": "The number of units of work that have been spent on this bug",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Scheduling.CompletedWork"
                    },
                    {
                        "name": "Description",
                        "referenceName": "System.Description",
                        "description": "Description or acceptance criteria for this epic to be considered complete",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.Description"
                    },
                    {
                        "name": "Effort",
                        "referenceName": "Microsoft.VSTS.Scheduling.Effort",
                        "description": "The estimated effort to implemented the epic",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Scheduling.Effort"
                    },
                    {
                        "name": "Finish Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.FinishDate",
                        "description": "The date to finish the task",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Scheduling.FinishDate"
                    },
                    {
                        "name": "History",
                        "referenceName": "System.History",
                        "description": "Discussion thread plus automatic record of changes",
                        "type": "history",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.History"
                    },
                    {
                        "name": "Integration Build",
                        "referenceName": "Microsoft.VSTS.Build.IntegrationBuild",
                        "description": "The build in which the bug was fixed",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Build.IntegrationBuild"
                    },
                    {
                        "name": "Issue",
                        "referenceName": "Microsoft.VSTS.Common.Issue",
                        "description": "Used to highlight the shared step, e.g., to mark it as an issue",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.Issue"
                    },
                    {
                        "name": "Iteration ID",
                        "referenceName": "System.IterationId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.IterationId"
                    },
                    {
                        "name": "Iteration Path",
                        "referenceName": "System.IterationPath",
                        "description": "The iteration within which this bug will be fixed",
                        "type": "treePath",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.IterationPath"
                    },
                    {
                        "name": "Local Data Source",
                        "referenceName": "Microsoft.VSTS.TCM.LocalDataSource",
                        "description": null,
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.LocalDataSource"
                    },
                    {
                        "name": "Parameters",
                        "referenceName": "Microsoft.VSTS.TCM.Parameters",
                        "description": null,
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.Parameters"
                    },
                    {
                        "name": "Priority",
                        "referenceName": "Microsoft.VSTS.Common.Priority",
                        "description": "Business importance. 1=must fix; 4=unimportant.",
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.Priority"
                    },
                    {
                        "name": "Query Text",
                        "referenceName": "Microsoft.VSTS.TCM.QueryText",
                        "description": null,
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.QueryText"
                    },
                    {
                        "name": "Rating",
                        "referenceName": "Microsoft.VSTS.Common.Rating",
                        "description": "Overall rating provided as part of feedback response",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.Rating"
                    },
                    {
                        "name": "Reason",
                        "referenceName": "System.Reason",
                        "description": "The reason why the bug is in the current state",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.Reason"
                    },
                    {
                        "name": "Remaining Work",
                        "referenceName": "Microsoft.VSTS.Scheduling.RemainingWork",
                        "description": "An estimate of the number of units of work remaining to complete this bug",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Scheduling.RemainingWork"
                    },
                    {
                        "name": "Resolved By",
                        "referenceName": "Microsoft.VSTS.Common.ResolvedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.ResolvedBy"
                    },
                    {
                        "name": "Resolved Date",
                        "referenceName": "Microsoft.VSTS.Common.ResolvedDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.ResolvedDate"
                    },
                    {
                        "name": "Reviewed By",
                        "referenceName": "Microsoft.VSTS.Common.ReviewedBy",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": true,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.ReviewedBy"
                    },
                    {
                        "name": "Stack Rank",
                        "referenceName": "Microsoft.VSTS.Common.StackRank",
                        "description": "Work first on items with lower-valued stack rank. Set in triage.",
                        "type": "double",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.StackRank"
                    },
                    {
                        "name": "Start Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.StartDate",
                        "description": "The date to start the task",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Scheduling.StartDate"
                    },
                    {
                        "name": "State",
                        "referenceName": "System.State",
                        "description": "New = for triage; Active = not yet fixed; Resolved = fixed not yet verified; Closed = fix verified.",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.State"
                    },
                    {
                        "name": "State Change Date",
                        "referenceName": "Microsoft.VSTS.Common.StateChangeDate",
                        "description": null,
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.StateChangeDate"
                    },
                    {
                        "name": "State Code",
                        "referenceName": "Microsoft.VSTS.Common.StateCode",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Common.StateCode"
                    },
                    {
                        "name": "Steps",
                        "referenceName": "Microsoft.VSTS.TCM.Steps",
                        "description": "Steps required to perform the test",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.Steps"
                    },
                    {
                        "name": "System Info",
                        "referenceName": "Microsoft.VSTS.TCM.SystemInfo",
                        "description": "Test context, provided automatically by test infrastructure",
                        "type": "html",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.SystemInfo"
                    },
                    {
                        "name": "Tags",
                        "referenceName": "System.Tags",
                        "description": null,
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.Tags"
                    },
                    {
                        "name": "Target Date",
                        "referenceName": "Microsoft.VSTS.Scheduling.TargetDate",
                        "description": "The target date for completing the epic",
                        "type": "dateTime",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.Scheduling.TargetDate"
                    },
                    {
                        "name": "Team Project",
                        "referenceName": "System.TeamProject",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.TeamProject"
                    },
                    {
                        "name": "Test Suite Audit",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteAudit",
                        "description": "Captures the test suite audit trail.",
                        "type": "plainText",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": false,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteAudit"
                    },
                    {
                        "name": "Test Suite Type",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteType",
                        "description": "Specifies the category of the test suite.",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteType"
                    },
                    {
                        "name": "Test Suite Type Id",
                        "referenceName": "Microsoft.VSTS.TCM.TestSuiteTypeId",
                        "description": null,
                        "type": "integer",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/Microsoft.VSTS.TCM.TestSuiteTypeId"
                    },
                    {
                        "name": "Title",
                        "referenceName": "System.Title",
                        "description": "Stories affected and how",
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.Title"
                    },
                    {
                        "name": "Issue Type",
                        "referenceName": "System.IssueType",
                        "description": null,
                        "type": "string",
                        "usage": "issue",
                        "readOnly": false,
                        "canSortBy": true,
                        "isQueryable": true,
                        "isIdentity": false,
                        "isPicklist": false,
                        "isPicklistSuggested": false,
                        "url": "https://dev.azure.com/devopsintegrationio/19720a67-640b-4be6-a041-4f05a404ac66/_apis/wit/fields/System.IssueType"
                    },
                    {
                        "name": "Issue #",
                        "referenceName": "id",
                        "type": "number"
                    }
                ]
            },
            "usersList": {
                "count": 3,
                "value": [
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "devopsintegration.dev@gmail.com",
                        "mailAddress": "devopsintegration.dev@gmail.com",
                        "origin": "msa",
                        "originId": "000300003A96BD95",
                        "displayName": "devopsintegration.dev",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj",
                        "descriptor": "msa.M2MwMmMzNDgtM2QyZC03MzBhLThjMTktYzYyOTBlMmI1NTFj"
                    },
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "support@devopsintegration.io",
                        "mailAddress": "support@devopsintegration.io",
                        "origin": "msa",
                        "originId": "000300003A96D958",
                        "displayName": "Jira Support",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3",
                        "descriptor": "msa.MmE0OTJjMGQtMzE3ZS03NmQ1LTgwNDEtMzU5M2M1ZDhiYzI3"
                    },
                    {
                        "subjectKind": "user",
                        "domain": "Windows Live ID",
                        "principalName": "devopsintegration.io@outlook.com",
                        "mailAddress": "devopsintegration.io@outlook.com",
                        "origin": "msa",
                        "originId": "00037FFE39B2B15E",
                        "displayName": "Jira Integration",
                        "_links": {
                            "self": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "memberships": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Memberships/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "membershipState": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/MembershipStates/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "storageKey": {
                                "href": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/StorageKeys/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            },
                            "avatar": {
                                "href": "https://dev.azure.com/devopsintegrationio/_apis/GraphProfile/MemberAvatars/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                            }
                        },
                        "url": "https://vssps.dev.azure.com/devopsintegrationio/_apis/Graph/Users/msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi",
                        "descriptor": "msa.ZjRhZDU4MGYtZGE4YS03YzQwLWFhMmItZmJjODlhMWEwNmRi"
                    }
                ]
            }
        }
    }
]